export enum NotificationListTypes {
    DRAFT = 'draft',
    NOTIFICATION = 'notification',
}
